export const MODULE = "planner/alerts";

export const ALERT_VARIANT = {
  SUCCESS: "success",
  DANGER: "danger",
};

// Which restore an alert's Undo runs. The alert slice stays serializable, so it carries this tag
// instead of a callback and PlannerAlerts maps it to the matching thunk.
export const UNDO_KIND = {
  REMOVE_EVENT: "remove-event",
  CLEAR_ALL_COLOURS: "clear-all-colours",
  REMOVE_ASSIGNEE: "remove-assignee",
  ADD_TIMESLOT: "add-timeslot",
};

// Undo kinds whose toasts replace each other instead of stacking: two assignee removals in a row
// show one toast, for the latest removal (product decision, FAC-5975).
export const REPLACING_UNDO_KINDS = [UNDO_KIND.REMOVE_ASSIGNEE];
